import {get} from '@/lib/fetcher';

export default {
    namespaced: true,
    state: () => ({
        matches: []
    }),
    mutations: {
        changeMatches(state, matches) {
            state.matches = matches;
        }
    },
    actions: {
        loadMatches({commit}) {
            get('/api/match')
                .then(resp => {
                    commit('changeMatches', resp);
                });
        }
    },
    getters: {
        matches: state => state.matches,
    }
};
